import api, { openApi } from "../../services/api";

const useSettings = () => {
  const getAll = async (params) => {
    const { data } = await api.request({
      url: "/settings",
      method: "GET",
      params,
    });
    return data;
  };

  const update = async (data) => {
    const { data: responseData } = await api.request({
      url: `/settings/${data.key}`,
      method: "PUT",
      data,
    });
    console.log(responseData);
    return responseData;
  };

  const get = async (param) => {
    const { data } = await api.request({
      url: `/setting/${param}`,
      method: "GET",
    });
    return data;
  };

  const getPublicSetting = async (key, companyId = null) => {
    const params = companyId ? { companyId } : {};
    const { data } = await openApi.request({
      url: `/public-settings/${key}`,
      method: "GET",
      params,
    });
    return data;
  };

  // Busca setting global (da company master - ID 1) usando autenticação
  const getGlobalSetting = async (key) => {
    const { data } = await api.request({
      url: `/setting-global/${key}`,
      method: "GET",
    });
    return data;
  };

  return {
    getAll,
    update,
    get,
    getPublicSetting,
    getGlobalSetting,
  };
};

export default useSettings;
